import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

export const BranchDailyStaffReportConfig = {
	id: DYNAMICLISTS.BRANCH_DAILY_STAFF_REPORT,
	columns: [
		{
			Header: 'branchID',
			accessor: 'branchID',
			filterType: FilterType.number,
			width: 50,
			show: false
		},
		{
			Header: 'fullname',
			accessor: 'fullname',
			filterType: FilterType.string,
			showOnMobile: true
		},
		{
			Header: 'branchName',
			accessor: 'branchName',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.BRANCHES,
			width: 120,
			showOnMobile: true
		},
		{
			Header: 'dateOfShipment',
			accessor: 'dateOfShipment',
			filterType: FilterType.date,
			renderCell: ListComponents.DATE,
			filterRemovable: false,
			customFilterOptions: [FilterAction.between, FilterAction.on],
			showOnMobile: true
		},
		{
			Header: 'numberOfShipments',
			accessor: 'numberOfShipments',
			showOnMobile: true,
			filterType: FilterType.float
		},
		{
			Header: 'orderIds',
			accessor: 'orderIds',
			filterType: FilterType.string,
			showOnMobile: true,
			customFilterOptions: [FilterAction.is, FilterAction.multipleFilter, FilterAction.contains],
			customHeaderFilterAction: FilterAction.is
		}
	],
	fetchUrl: REPORT.LIST.GET_BRANCH_DAILY_STAFF_REPORT_LIST,
	exportName: 'branchDailyStaffReport'
};

const BranchDailyStaffReport = () => {
	const { state } = useLocation();

	const defaultFilters = useMemo(() => {
		if (!state?.data || Object.keys(state?.data)?.length === 0) {
			return [];
		}

		return [
			{
				column: BranchDailyStaffReportConfig.columns.find((c) => c.accessor === 'dateOfShipment'),
				action: FilterAction.between,
				value: state.data.date
			}
		];
	}, []);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="branchDailyStaffReport"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.BRANCH_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList {...BranchDailyStaffReportConfig} defaultFilters={defaultFilters} />
		</div>
	);
};

export default BranchDailyStaffReport;
